import Vue from 'vue'

import App from './App'
import store from './v2/store/store'
import router from './router'

import 'core-js/stable'
import 'regenerator-runtime/runtime'

// third parties
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'
import VueScreen from 'vue-screen'
import VueScrollTo from 'vue-scrollto'
import Loading from 'vue-loading-overlay'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { extend } from 'vee-validate';
import { required, numeric, max, min, between, integer, min_value } from 'vee-validate/dist/rules'

// vee-validate interaction mode
import { setInteractionMode } from 'vee-validate'
setInteractionMode('eager')

// vee-validate rule overrides
extend('required', {...required, message: '{_field_} is required.' })
extend('between', between)
extend('numeric', {...numeric, message: '{_field_} must be a whole number.' })
extend('min', {...min, message: '{_field_} must be a minimum of {length} chars.' })
extend('max', {...max, message: '{_field_} must be {length} characters or less.' })
extend('integer', {...integer, message: 'Please enter a valid {_field_} to the nearest pound.' })
extend('min_value', {...min_value, message: '{_field_} must be at least £{min}' })

// eslint-disable-next-line
extend('decimal', value => RegExp('\^\\d\+\(\\\.\\d\)\?\\d\*\$').test(value))
    // eslint-disable-next-line
extend('email', value => RegExp('\^\(\[a\-zA\-Z0\-9_\\\-\\\.\]\+\)@\(\(\\\[\[0\-9\]\{1,3\}\\\.\[0\-9\]\{1,3\}\\\.\[0\-9\]\{1,3\}\\\.\)\|\(\(\[a\-zA\-Z0\-9\\\-\]\+\\\.\)\+\)\)\(\[a\-zA\-Z\]\{2,4\}\|\[0\-9\]\{1,3\}\)\(\\\]\?\)\$').test(value))

extend('postcode', value => {

    // eslint-disable-next-line
    const postcodeRegex = RegExp('\(\[Gg\]\[Ii\]\[Rr\] 0\[Aa\]\{2\}\)\|\(\(\(\[A\-Za\-z\]\[0\-9\]\{1,2\}\)\|\(\(\[A\-Za\-z\]\[A\-Ha\-hJ\-Yj\-y\]\[0\-9\]\{1,2\}\)\|\(\(\[A\-Za\-z\]\[0\-9\]\[A\-Za\-z\]\)\|\(\[A\-Za\-z\]\[A\-Ha\-hJ\-Yj\-y\]\[0\-9\]\[A\-Za\-z\]\?\)\)\)\)\\s\?\[0\-9\]\[A\-Za\-z\]\{2\}\)')

    // eslint-disable-next-line
    const excludedRegionsPostCodes = RegExp('(GY|IM|JE)[0-9]{1,2}[ ]?[0-9]([a-zA-Z]{1,2})', 'i')

    if (excludedRegionsPostCodes.test(value)) {
        return 'The Post Office Credit Card is only available to UK residents'
    } else if (!postcodeRegex.test(value)) {
        return 'Please enter a valid post code'
    }

    return true

})

Vue.use(Loading, {
    color: '#58595b',
    opacity: 0.6
})

Vue.use(Vuex)
Vue.use(VueScreen, 'tailwind')

const userPrefersReducedMotion = !window.matchMedia('(prefers-reduced-motion: no-preference)').matches

Vue.use(VueScrollTo, {
    duration: userPrefersReducedMotion ? 0 : 500,
    easing: 'ease',
    offset: -50,
})

Vue.use(VueAxios, axios)
Vue.use(VueRouter)

// components
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

// disable vue production tip
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// eslint-disable-next-line no-console
console.log(
    `%c Post Office %c Credit Card QuickCheck ${process.env.VERSION} %c ${process.env.NODE_ENV}`,
    'background:#cb1339; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
    'background:#f5f5f5; padding: 1px; color: #000',
    'background:#4B0082; padding-right: 5px; border-radius: 0px 3px 3px 0px; color: #fff'
)

new Vue({
    render: h => h(App),
    router,
    store,
}).$mount('#app')